export { default } from './FavoritesCarouselSnap';
